import React, { useState, useEffect } from 'react';

/**
 * OptimizedBackground Component
 * Handles background image loading with optimization techniques
 */
const OptimizedBackground = ({ 
  imageUrl, 
  className, 
  style = {},
  fallbackColor = '#1a1a2e',
  children 
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const img = new Image();
    
    // Preload the image
    img.onload = () => {
      setIsLoaded(true);
    };
    
    img.onerror = () => {
      setError(true);
      console.error(`Failed to load background image: ${imageUrl}`);
    };
    
    img.src = imageUrl;
    
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageUrl]);

  const backgroundStyle = {
    ...style,
    backgroundColor: fallbackColor,
    backgroundImage: isLoaded && !error ? `url(${imageUrl})` : 'none',
    transition: 'background-image 0.3s ease-in',
  };

  return (
    <div className={className} style={backgroundStyle}>
      {children}
    </div>
  );
};

export default OptimizedBackground;